export const SET_FORUM_DATA = 'forumData/SET';

export const setForumData = payload => ({
  type: SET_FORUM_DATA,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/set-forum-data.js